import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ResActionsService {
  refreshList = new BehaviorSubject<boolean>(false);
  refreshDetails = new BehaviorSubject<boolean>(false);
  createFormSubmitted = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  PrintTill(data: any) {
    return this.http.post(`${environment.apiUrl}/ResRestaurant/PrintTill`, data);
  }

  GetAllCashierRestaurantTeam(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/GetAllCashierRestaurantTeam?restaurantId=${restaurantId}`);
  }
}
